var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('app-placeholder-horizontal',{attrs:{"imageId":_vm.form.imageId},on:{"upload":_vm.onUpload}})}
var staticRenderFns = []

export { render, staticRenderFns }